import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 7px;
  width: 100%;
`

export interface StepProps {
  active: boolean
}

export const Step = styled.div<StepProps>`
  width: 100%;
  height: 8px;
  background: ${(props) => (props.active ? '#5298F5' : '#B9D3F4')};
`
